export enum ArtifactStatus {
  /**
   * The artifact is still being generated or processed.
   * UI should display a loading indicator or show partial code/content.
   * User interactions with the artifact may be limited during this state.
   */
  PROCESSING = 'processing',

  /**
   * The artifact rendering is complete and it's in an active state.
   * For interactive artifacts (forms, calculators, etc.), this indicates
   * the artifact is ready and waiting for user input or interaction.
   * UI should show the artifact as fully interactive.
   */
  RUNNING = 'running',

  /**
   * The artifact rendering is complete but it's in an inactive state.
   * For interactive artifacts, this indicates the artifact is not expecting
   * any further input from the user.
   * UI should show the artifact as read-only or with limited interactivity.
   */
  IDLE = 'idle',

  /**
   * The artifact is being built by the system.
   */
  BUILDING = 'building',

  /**
   * The artifact is being unit tested by the system.
   */
  TESTING = 'testing',

  /**
   * The artifact failed to generate
   */
  ERROR = 'error',
}

export enum ArtifactType {
  /**
   * The artifact is embedded within chat message, html is sanitized to very basic tags.
   * Applies only to text/html and text/markdown content types.
   */
  INLINE = 'inline',
  /**
   * The artifact is embedded within chat message, in an iframe with support of iframe-proxy API
   */
  INLINE_INTERACTIVE = 'inline-interactive',
  /**
   * The artifact is rendered as a button that opens artifact in an iframe with support of iframe-proxy API
   * @see iframe-proxy.md
   */
  STANDALONE = 'standalone',
}

// Base Artifact type
export interface Artifact {
  uuid: string
  title: string
  description?: string
  icon?: string
  type: ArtifactType
  /** The content of the artifact, which can be HTML, Markdown, or JSON with wippy specific package.json info */
  content_type: 'text/html' | 'text/markdown' | 'application/json'
  content_version?: string
  status: ArtifactStatus
}
